export const uiVariantOptions = [
  { label: 'PC', value: 'PC' },
  { label: 'AdOps', value: 'AdOps' },
  { label: 'Accounting', value: 'Accounting' },
  { label: 'SalesBackoffice', value: 'SalesBackoffice' },
  { label: 'Lead', value: 'Lead' },
  { label: 'Collabary', value: 'Collabary' },
];

export const uiVariants = {
  PC: 'PC',
  ADOPS: 'AdOps',
  ACCOUNTING: 'Accounting',
  SALESBACKOFFICE: 'SalesBackoffice',
  LEAD: 'Lead',
  COLLABARY: 'Collabary',
};

export const userFilterFields = ['email', 'firstName', 'lastName'];

export const userSelectLabel = object => {
  return `${object.firstName} ${object.lastName}`;
};

const SUPERUSER = 'Superuser';
const UNIVERSAL = 'UNIVERSAL';
const READ_ONLY = 'Read-Only';
const MANAGEMENT = 'Management';
const ACCOUNTING_TEAM = 'Accounting Team';
const ACCOUNTING_LEAD = 'Accounting Lead';
const BUSINESS_DEVELOPMENT_LEAD = 'Business Development Lead';
const BUSINESS_DEVELOPMENT_TEAM = 'Business Development Team';
const MA_CONTROLLING_LEAD = 'M&A/Controlling Lead';
const MA_CONTROLLING_TEAM = 'M&A/Controlling Team';
const OPS_CI_LEAD = 'Ops CI Lead';
const OPS_CI_TEAM = 'Ops CI Team';
const OPS_CREATIVE_LEAD = 'Ops Creative Lead';
const OPS_CREATIVE_TEAM = 'Ops Creative Team';
const OPS_DATA_BUSINESS_LEAD = 'Ops Data Business Lead';
const OPS_DATA_BUSINESS_TEAM = 'Ops Data Business Team';
const OPS_MEDIA_PLANNING_LEAD = 'Ops Media Planning Lead';
const OPS_MEDIA_PLANNING_TEAM = 'Ops Media Planning Team';
const OPS_ONSITE_LEAD = 'Ops Onsite Lead';
const OPS_ONSITE_TEAM = 'Ops Onsite Team';
const OPS_PAID_SOCIAL_LEAD = 'Ops Paid Social Lead';
const OPS_PAID_SOCIAL_TEAM = 'Ops Paid Social Team';
const OPS_PROGRAMMATIC_LEAD = 'Ops Programmatic Lead';
const OPS_PROGRAMMATIC_TEAM = 'Ops Programmatic Team';
const PARTNER_CONSULTANCY_LEAD = 'Partner Consultancy Lead';
const PARTNER_CONSULTANCY_TEAM = 'Partner Consultancy Team';
const MARKETING_TEAM = 'Marketing Team';
const MARKETING_LEAD = 'Marketing Lead';
const COLLABARY_PARTNER_CONSULTANCY_TEAM = 'Collabary Partner Consultancy Team';
const COLLABARY_PARTNER_CONSULTANCY_LEAD = 'Collabary Partner Consultancy Lead';
const SALES_BACK_OFFICE_TEAM = 'Sales Backoffice Team';
const SALES_BACK_OFFICE_LEAD = 'Sales Backoffice Lead';
const COLLABARY_SAAS_LEAD = 'Collabary SaaS Lead';
const COLLABARY_SAAS_TEAM = 'Collabary SaaS Team';
const PSM_LEAD = 'PSM Lead';
const PSM_TEAM = 'PSM Team';

export const rolesEnum = {
  SUPERUSER,
  UNIVERSAL,
  READ_ONLY,
  MANAGEMENT,
  ACCOUNTING_TEAM,
  ACCOUNTING_LEAD,
  BUSINESS_DEVELOPMENT_LEAD,
  BUSINESS_DEVELOPMENT_TEAM,
  MA_CONTROLLING_LEAD,
  MA_CONTROLLING_TEAM,
  MARKETING_TEAM,
  MARKETING_LEAD,
  COLLABARY_PARTNER_CONSULTANCY_TEAM,
  COLLABARY_PARTNER_CONSULTANCY_LEAD,
  OPS_CI_LEAD,
  OPS_CI_TEAM,
  OPS_CREATIVE_LEAD,
  OPS_CREATIVE_TEAM,
  OPS_DATA_BUSINESS_LEAD,
  OPS_DATA_BUSINESS_TEAM,
  OPS_MEDIA_PLANNING_LEAD,
  OPS_MEDIA_PLANNING_TEAM,
  OPS_ONSITE_LEAD,
  OPS_ONSITE_TEAM,
  OPS_PAID_SOCIAL_LEAD,
  OPS_PAID_SOCIAL_TEAM,
  OPS_PROGRAMMATIC_LEAD,
  OPS_PROGRAMMATIC_TEAM,
  PARTNER_CONSULTANCY_LEAD,
  PARTNER_CONSULTANCY_TEAM,
  SALES_BACK_OFFICE_TEAM,
  SALES_BACK_OFFICE_LEAD,
  COLLABARY_SAAS_LEAD,
  COLLABARY_SAAS_TEAM,
  PSM_LEAD,
  PSM_TEAM,
};

export const roles = Object.values(rolesEnum);

export const roleToRoles = {
  SUPERUSER: roles,
  ACCOUNTING_LEAD: [ACCOUNTING_LEAD, ACCOUNTING_TEAM],
  BUSINESS_DEVELOPMENT_LEAD: [
    BUSINESS_DEVELOPMENT_LEAD,
    BUSINESS_DEVELOPMENT_TEAM,
  ],
  COLLABARY_PARTNER_CONSULTANCY_LEAD: [
    COLLABARY_PARTNER_CONSULTANCY_LEAD,
    COLLABARY_PARTNER_CONSULTANCY_TEAM,
  ],
  MA_CONTROLLING_LEAD: [MA_CONTROLLING_LEAD, MA_CONTROLLING_TEAM],
  MARKETING_LEAD: [MARKETING_LEAD, MARKETING_TEAM],
  OPS_CI_LEAD: [OPS_CI_LEAD, OPS_CI_TEAM],
  OPS_CREATIVE_LEAD: [OPS_CREATIVE_LEAD, OPS_CREATIVE_TEAM],
  OPS_DATA_BUSINESS_LEAD: [OPS_DATA_BUSINESS_LEAD, OPS_DATA_BUSINESS_TEAM],
  OPS_MEDIA_PLANNING_LEAD: [OPS_MEDIA_PLANNING_LEAD, OPS_MEDIA_PLANNING_TEAM],
  OPS_ONSITE_LEAD: [
    OPS_ONSITE_LEAD,
    OPS_ONSITE_TEAM,
    OPS_PAID_SOCIAL_LEAD,
    OPS_PAID_SOCIAL_TEAM,
    OPS_PROGRAMMATIC_LEAD,
    OPS_PROGRAMMATIC_TEAM,
    OPS_MEDIA_PLANNING_LEAD,
    OPS_MEDIA_PLANNING_TEAM,
  ],
  OPS_PAID_SOCIAL_LEAD: [OPS_PAID_SOCIAL_LEAD, OPS_PAID_SOCIAL_TEAM],
  OPS_PROGRAMMATIC_LEAD: [OPS_PROGRAMMATIC_LEAD, OPS_PROGRAMMATIC_TEAM],
  PARTNER_CONSULTANCY_LEAD: [
    PARTNER_CONSULTANCY_LEAD,
    PARTNER_CONSULTANCY_TEAM,
  ],
  SALES_BACK_OFFICE_LEAD: [SALES_BACK_OFFICE_LEAD, SALES_BACK_OFFICE_TEAM],
  COLLABARY_SAAS_LEAD: [COLLABARY_SAAS_LEAD, COLLABARY_SAAS_TEAM],
};
